<template>
  <div class="flex_vh100 home">
    <div>
      <!-- 顶部导航 -->
      <van-nav-bar
        title="私人组局记录"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      >
        <template #right>
          <van-icon
            name="filter-o"
            size="20"
            @click="showFilter = !showFilter"
          />
        </template>
      </van-nav-bar>
    </div>
    <div class="flex_vh100">
      <UniversalSearch
        v-show="showFilter"
        ref="universalSearch"
        title="筛选"
        :initial-form-data="formData"
        @search="handleSearch"
        @reset="handleReset"
      >
        <template #search-content="{ formData, handleSearch }">
          <div class="search-fields">
            <div class="search-row">
              <div class="search-input">
                <van-field
                  v-model="formData.number"
                  placeholder="房间号"
                  clearable
                  :autofocus="false"
                  @keyup.enter="handleSearch"
                >
                </van-field>
              </div>
            </div>
            <div class="search-row">
              <div class="search-input">
                <van-field
                  v-model="formData.replaybk_number"
                  placeholder="回放码"
                  clearable
                  :autofocus="false"
                  @keyup.enter="handleSearch"
                >
                </van-field>
              </div>
            </div>
          </div>
        </template>
      </UniversalSearch>

      <!-- 列表 -->
      <ListPage
        ref="listPage"
        :request-api="_getGamePrivateLog"
        :params="searchInfo"
        class="flex_vh100"
      >
        <template #default="{ list }">
          <div class="product-grid">
            <div v-for="item in list" :key="item.id" class="product-item">
              <van-cell-group>
                <van-cell
                  title="组局编号 / 所属区域"
                  :value="item.teamId + ' / ' + item.regionName"
                ></van-cell>
                <van-cell
                  title="房间"
                  :value="item.privateRoomName"
                  :label="item.roomName"
                ></van-cell>
                <van-cell
                  title="房主"
                  :value="
                    item.number +
                    (item.nickname ? '(' + item.nickname + ')' : '')
                  "
                ></van-cell>
                <van-cell
                  title="房间类型 / 房间号"
                  :value="item.typeStr + ' / ' + item.number"
                ></van-cell>
                <van-cell title="游戏局数" :value="item.maxRounds"></van-cell>
                <van-cell
                  title="最后一局"
                  :value="item.lastRoundNo + '(' + item.lastRoundTime + ')'"
                ></van-cell>
                <van-cell title="创建时间" :value="item.createTime"></van-cell>
              </van-cell-group>
            </div>
          </div>
        </template>
      </ListPage>
    </div>
  </div>
</template>

<script>
import ListPage from "./controls/ListPage.vue";
import UniversalSearch from "./controls/UniversalSearch.vue";
import { GetGamePrivateLog } from "../api/financeapi.js";
export default {
  name: "PrivateGameLog",
  components: { ListPage, UniversalSearch },
  data() {
    const now = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(now.getFullYear() - 1);
    return {
      showFilter: false, // 筛选区域是否显示
      isCollapsed: false, // 搜索区域是否收缩
      formData: {
        number: "",
        replaybk_number: "",
      },
      searchInfo: {
        number: "",
        replaybk_number: "",
      },
    };
  },
  watch: {
    showFilter(val) {
      if (this.$refs.universalSearch) {
        val
          ? this.$refs.universalSearch.expand()
          : this.$refs.universalSearch.collapse();
      }
    },
    $route(to) {
      // 路由变化时更新激活的标签
      if (to.name == "PrivateGameLog") {
      }
    },
  },
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1); // 后退一步
    },
    // 执行搜索
    handleSearch(searchParams) {
      console.log(searchParams);
      this.searchInfo = searchParams;
    },

    // 重置搜索条件
    handleReset() {
      this.formData = {
        number: "",
        replaybk_number: "",
      };
    },

    //查询游戏私人房组局日志
    _getGamePrivateLog(params) {
      return GetGamePrivateLog(params);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.search-fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 隐藏 UniversalSearch 自带的 header，切换按钮已在导航栏 */
:deep(.collapsible-search .search-header) {
  display: none;
}

.search-row {
  display: flex;
  gap: 10px;
}

.search-row[style*="column"] {
  flex-direction: column;
}

.search-type {
  flex-shrink: 0;
  width: 110px;
}

.search-type :deep(.van-dropdown-menu__bar) {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: none;
  height: 36px;
  border: 1px solid #ebedf0;
}

.search-type :deep(.van-dropdown-menu__title) {
  padding: 0 10px;
  line-height: 34px;
  font-size: 13px;
}

.search-input {
  flex: 1;
}

.search-input :deep(.van-field) {
  background-color: #fff;
  border-radius: 6px;
  padding: 6px 10px;
  border: 1px solid #ebedf0;
}

.search-input :deep(.van-field__control) {
  font-size: 13px;
}

.search-input :deep(.van-field__right-icon),
.search-input :deep(.van-field__left-icon) {
  color: #1989fa;
  cursor: pointer;
}

.product-item {
  background-color: #fff;
  border-bottom: 1px solid #f5f6f8;
  margin-bottom: 10px;
}

.product-item :deep(.van-cell-group) {
  background-color: transparent;
}

.product-item :deep(.van-cell-group::after) {
  display: none;
}

.product-item :deep(.van-cell) {
  padding: 10px 14px;
  font-size: 13px;
  line-height: 1.5;
}

.product-item :deep(.van-cell::after) {
  display: none;
}

.product-item :deep(.van-cell__title) {
  color: #323233;
  font-size: 13px;
}

.product-item :deep(.van-cell__value) {
  color: #969799;
  font-size: 13px;
}

.cloth-icon {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  object-fit: cover;
  margin-right: 6px;
}
.custom-cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.cell-title {
  font-size: 13px;
  color: #323233;
}

.cell-label {
  font-size: 11px;
  color: #969799;
}

.cell-value {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #969799;
  font-size: 13px;
}

.cell-left {
  flex: 1;
}

.accountStyle {
  text-align: right;
}
</style>